var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#f7f7f8"}},[(!_vm.isPublic)?_c('dashboard-core-app-bar'):_vm._e(),(!_vm.isPublic)?_c('dashboard-core-drawer'):_vm._e(),_c('dashboard-core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }